var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.class,attrs:{"id":this.id+'_container'}},[_c('input',{attrs:{"id":this.id,"type":"checkbox"}})])}
var staticRenderFns = []

export { render, staticRenderFns }